import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITreeOptions, TreeComponent, TreeModel, TreeNode } from '@circlon/angular-tree-component';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { _isId } from 'app/services/auth.service';
import { PageService } from 'app/services/models/page.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { UserService } from 'app/services/models/user.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserDetailComponent implements OnInit, AfterViewInit {

  @ViewChild('treeComponent') private tree: TreeComponent | undefined;
  @BlockUI('section-block') blockUI: NgBlockUI;
  userTransaction :any[] = [];
  public contentHeader: object;
  public user: any = {};
  nodesAsync: any[] = [];
  selectedNodeIds: number[] = []; // Make sure this is declared

  getFormattedPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return '';

    // Telefon numarasını formatla
    const cleaned = ('' + phoneNumber).replace(/\D/g, ''); // Temizle
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/); // Formatla

    if (match) {
      return `(${match[1]}) ${match[2]} ${match[3]} ${match[4]}`;
    }

    return phoneNumber; // Formatlanmamış numara
  }

  optionsAsync: ITreeOptions = {
    getChildren: this.getAsyncChildren.bind(this),
    useCheckbox: true,
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private pageService: PageService,
    private cd: ChangeDetectorRef,
    private toastrService: ToastrService,
    private transactionService:TransactionService
  ) { }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Kullanıcı',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Kullanıcı Listesi',
            link: '/user',
            isLink: true,
          },
          {
            name: 'Kullanıcı Detay',
            isLink: false,
          },
        ]
      }
    };
    this.pageService.event$.subscribe(result => {
      this.activatedRoute.params.subscribe(async params => {
        await this.getByIdUser(params['id']);
      });
    })
    this.activatedRoute.params.subscribe(async params => {
      await this.getByIdUser(params['id']);
    });
    await this.getByUserIdTransactionManagementId(_isId);
  }

  async getByUserIdTransactionManagementId(id){
    const data = await this.transactionService.ByIdUserDetailTransaction(id);
    console.log(data);
    this.userTransaction = data;
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Teklif Oluşturuldu';
      case 2:
        return 'İptal Edildi';
      case 3:
        return 'Onaylandı';
      case 4:
        return 'Reddedildi';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'teklif':
        return 'badge badge-pill badge-light-primary';    
      case 'sipariş':
        return 'badge badge-pill badge-light-danger';  
      case 'alış':
        return 'badge badge-pill badge-light-success'; 
      case 'satış':
        return 'badge badge-pill badge-light-warning'; 
      default:
        return 'badge badge-pill badge-light-secondary'; 
    }
  }

  ngAfterViewInit() {
    this.blockUI.start('sayfalar yükleniyor...')
    setTimeout(() => {
      this.selectAllNodes();
      this.blockUI.stop();
    }, 1000);
  }

  async getByIdUser(id: number) {
    try {
      const data = await this.userService.getByIdUser(id);
      this.user = data;
      if (this.user) {
        await this.getAllUserPages(this.user.id);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  }

  async getAllUserPages(id: number) {
    try {
      const data = await this.pageService.getAllPages();
      this.nodesAsync = this.transformToNodes(data, id);
      this.cd.detectChanges();
    } catch (error) {
      console.error('Error fetching pages:', error);
    }
  }

  transformToNodes(data: any[], _isId: number): any[] {
    return data.map(node => {
      const isSelected = node.pageUsers.some(user => user.appUserId === _isId);

      return {
        id: node.id,
        name: node.title + " Sayfası",
        hasChildren: node.children && node.children.length > 0,
        children: node.children ? this.transformToNodes(node.children, _isId) : [],
        pageUsers: node.pageUsers,
        selected: isSelected,
      };
    });
  }

  selectAllNodes() {
    const treeModel: TreeModel = this.tree.treeModel;

    // Tüm düğümleri genişlet
    treeModel.expandAll();

    // Tüm kök düğümleri kontrol et
    treeModel.roots.forEach(node => {
      if (node) { // node'un null olup olmadığını kontrol et
        this.selectNodeIfSelected(node);
      } else {
        console.warn('Null node detected');
      }
    });
  }

  selectNodeIfSelected(node: TreeNode) {
    if (node.data.selected) {
      node.setIsSelected(true);
    } else {
      node.setIsSelected(false);
    }

    if (node.hasChildren) {
      node.children.forEach(childNode => this.selectNodeIfSelected(childNode));
    }
  }

  onNavChange() {
    this.blockUI.start('sayfalar yükleniyor...')
    setTimeout(() => {
      this.selectAllNodes()
      this.blockUI.stop();
    }, 1000);
   
  }

  onEventBlur(event: any) {
    const focusedNodeId = event.focusedNodeId;

    if (this.selectedNodeIds.includes(focusedNodeId)) {
      this.selectedNodeIds = this.selectedNodeIds.filter(id => id !== focusedNodeId);
    } else {
      this.selectedNodeIds.push(focusedNodeId);
    }
  }

  async saveUserPage() {
    this.selectedNodeIds = [];

    if (this.tree?.treeModel) {
      const treeModel: TreeModel = this.tree.treeModel;

      treeModel.roots.forEach(node => this.collectSelectedIds(node));

      const data = await this.pageService.createUserPages(this.user.id, this.selectedNodeIds);

      if (data.status) {
        this.pageService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }

    console.log('Seçili ID\'ler:', this.selectedNodeIds);
  }

  collectSelectedIds(node: TreeNode) {
    if (node.isSelected) {
      this.selectedNodeIds.push(node.data.id);
    }

    if (node.hasChildren) {
      node.children.forEach(childNode => this.collectSelectedIds(childNode));
    }
  }

  getAsyncChildren() {
    return new Promise((resolve) => {
      resolve(this.nodesAsync);
    });
  }
}
